import { render, staticRenderFns } from "./BatchTasksTable.vue?vue&type=template&id=143cc069&scoped=true"
import script from "./BatchTasksTable.vue?vue&type=script&lang=ts"
export * from "./BatchTasksTable.vue?vue&type=script&lang=ts"
import style0 from "./BatchTasksTable.vue?vue&type=style&index=0&id=143cc069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cc069",
  null
  
)

export default component.exports